import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { castDraft, immerable, produce } from 'immer';
import { Map } from 'immutable';

import { AccessConsumerItemEntity } from './access-consumer-item.entity';

export interface IMemberListExtra
	extends IListColumnConfig<AccessConsumerItemEntity> {
	width?: string | number;
}

interface IAccessConsumerList extends IListAttrs<AccessConsumerItemEntity> {
	availableColumns: Map<string, IMemberListExtra>;
}

const entityDefaults: IAccessConsumerList = {
	elements: Map(),
	availableColumns: Map(),
};

export class AccessConsumerListEntity
	implements
		IAccessConsumerList,
		IListOperations<AccessConsumerListEntity, AccessConsumerItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;
	public static build(
		availableCols: Array<IMemberListExtra>
	): AccessConsumerListEntity {
		const inst = new AccessConsumerListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IMemberListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	public constructor(params: Partial<IAccessConsumerList> = {}) {
		this.availableColumns =
			params.availableColumns ?? entityDefaults.availableColumns;
		this.elements = params.elements ?? entityDefaults.elements;
		return this;
	}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<AccessConsumerItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(
		elems: Map<string, AccessConsumerItemEntity>
	): AccessConsumerListEntity {
		return produce(this, (draft) => {
			draft.elements = castDraft(elems);
		});
	}

	public setMemberListData(
		elems: Map<string, AccessConsumerItemEntity>
	): AccessConsumerListEntity {
		return produce(this, (draft) => {
			draft.elements = castDraft(elems);
		});
	}
}
